import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
    findAll({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/service/condition/findAll`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  selectYearsList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/service/condition/selectYearsList`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  delConfig({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/service/condition/deleteConfigServiceCondition`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  saveConfig({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/service/condition/saveConfigServiceCondition`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },

  findConfigServiceConditionArt({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/service/condition/findConfigServiceConditionArt`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },

  getProvinceIdExisting({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/service/condition/selectAll`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
 
};
